export const brandModelData = {
  Telefona: {
    Apple: [
      "iPhone 7",
      "iPhone 7 Plus",
      "iPhone 8",
      "iPhone 8 Plus",
      "iPhone X",
      "iPhone XR",
      "iPhone XS",
      "iPhone XS Max",
      "iPhone 11",
      "iPhone 11 Pro",
      "iPhone 11 Pro Max",
      "iPhone 12 mini",
      "iPhone 12",
      "iPhone 12 Pro",
      "iPhone 12 Pro Max",
      "iPhone 13 mini",
      "iPhone 13",
      "iPhone 13 Pro",
      "iPhone 13 Pro Max",
      "iPhone 14",
      "iPhone 14 Plus",
      "iPhone 14 Pro",
      "iPhone 14 Pro Max",
      "iPhone 15",
      "iPhone 15 Plus",
      "iPhone 15 Pro",
      "iPhone 15 Pro Max",
      "iPhone 16",
      "iPhone 16 Plus",
      "iPhone 16 Pro",
      "iPhone 16 Pro Max",
      "iPhone 16e",
      "iPhone 17",
      "iPhone 17 Pro",
      "iPhone 17 Pro Max",
    ],
    Samsung: {
      S: [
        "Galaxy S26",
        "Galaxy S26+",
        "Galaxy S26 Ultra",
        "Galaxy S25",
        "Galaxy S25+",
        "Galaxy S25 Ultra",
        "Galaxy S25 Edge",
        "Galaxy S25 FE",
      ],
      Z: [
        "Galaxy Z Fold 7",
        "Galaxy Z Flip 7",
        "Galaxy Z Fold 6",
        "Galaxy Z Flip 6",
      ],
      A: [
        "Galaxy A77",
        "Galaxy A76",
        "Galaxy A57",
        "Galaxy A56",
        "Galaxy A37",
        "Galaxy A36",
        "Galaxy A33",
        "Galaxy A32",
      ],
      M: ["Galaxy M57", "Galaxy M56", "Galaxy M36", "Galaxy M32"],
    },
    Xiaomi: {
      Redmi: ["Redmi Note 12", "Redmi Note 11"],
      Mi: ["Mi 12", "Mi 11 Lite"],
      Poco: ["Poco X4", "Poco F4"],
    },
    OnePlus: {
      OnePlus: ["OnePlus 11", "OnePlus 10 Pro"],
      Nord: ["OnePlus Nord 2"],
    },
    Google: {
      Pixel: ["Pixel 7", "Pixel 6", "Pixel 6a"],
    },
    Huawei: {
      P: ["P50 Pro"],
      Mate: ["Mate 40"],
      Nova: ["Nova 9"],
    },
  },

  Laptop: {
    Dell: ["XPS 13", "Inspiron 15", "Latitude 5420", "G15", "Vostro 5400"],
    HP: ["Pavilion 15", "Envy 13", "Spectre x360", "Omen 16", "EliteBook 840"],
    Lenovo: ["ThinkPad X1", "Yoga 7", "Legion 5", "IdeaPad 3", "ThinkBook 15"],
    Asus: ["ROG Zephyrus G14", "VivoBook S15", "ZenBook 14"],
    Acer: ["Swift 3", "Aspire 5", "Predator Helios 300"],
    Apple: ["MacBook Air M2", "MacBook Pro 14", "MacBook Pro 16"],
  },

  Tablete: {
    Apple: ["iPad Pro", "iPad Air", "iPad Mini", "iPad 10th Gen"],
    Samsung: [
      "Galaxy Tab S8",
      "Galaxy Tab A7",
      "Galaxy Tab S7",
      "Galaxy Tab S6 Lite",
    ],
    Lenovo: ["Tab P11", "Yoga Tab 13", "Tab M10", "Tab P12 Pro"],
    Microsoft: ["Surface Pro 9", "Surface Go 3"],
    Huawei: ["MatePad Pro", "MatePad 11"],
  },

  // ✅ KATEGORITE E REJA

  Kufje: {
    Apple: ["AirPods 2", "AirPods 3", "AirPods Pro", "AirPods Pro 2"],
    Samsung: ["Galaxy Buds", "Galaxy Buds 2", "Galaxy Buds Pro"],
    Sony: ["WH-1000XM4", "WH-1000XM5"],
    JBL: ["Tune 510BT", "Live 660NC"],
    Xiaomi: ["Redmi Buds 3", "Mi True Wireless"],
  },

  Smartwatch: {
    Apple: ["Apple Watch Series 7", "Series 8", "Series 9", "Ultra"],
    Samsung: ["Galaxy Watch 4", "Watch 5", "Watch 6"],
    Huawei: ["Watch GT 3", "Watch GT 4"],
    Xiaomi: ["Mi Watch", "Redmi Watch 3"],
  },

  Aksesore: {
      Karikues:[""],
      Kelluf:[""],
      USB:[""],
      PowerBank:[""],
      Adaptor:[""],
      Mbrojtese:[""],
    
  },
};
